import React from 'react';
import PropTypes from 'prop-types';


import * as styleUtils from '../../../../utils/styleUtils';
import * as trendConstants from '../trendConstants';

import {I18nMessage} from '../../I18n';

import TrendMatchQuota from '../TrendMatchQuota';

import styles from './TrendKeywordMatchQuotas.scss';


function TrendKeywordMatchQuotas({keywordMatchQuotas}) {

    // edge-case: no keywords present
    if (keywordMatchQuotas.length === 0) {

        return null;
    }

    const getStyle = quota => {

        for (let i = 0; i < trendConstants.QUOTA_THRESHOLDS.length; i++) {
            const quotaThreshold = trendConstants.QUOTA_THRESHOLDS[i];
            if (quota >= quotaThreshold.threshold) {

                return quotaThreshold.className;
            }
        }

        return null;
    };

    return (
        <div className={styles.keywordMatchQuotas}>

            <h4>
                <I18nMessage id={'trend.keywordMatchQuotas.headline'}/>
            </h4>

            {keywordMatchQuotas.map(({keyword, quota}, i) => (
                <p
                    className={getStyle(quota)}
                    key={`keyword-match-quota-${i}`}
                >
                    {keyword}
                    <span>
                        <TrendMatchQuota quota={quota}/>
                    </span>
                </p>
            ))}

        </div>
    );
}


TrendKeywordMatchQuotas.propTypes = {
    keywordMatchQuotas: PropTypes.arrayOf(
        PropTypes.shape(trendConstants.SHAPE_KEYWORD_MATCH_QUOTA)
    ).isRequired
};

TrendKeywordMatchQuotas.defaultProps = {};


export default TrendKeywordMatchQuotas;
